<template>
  <div>
    <v-container style="max-width: 1185px;">
      <v-row justify="center">
        <v-col
          cols="12"
          cols-md="10"
          align-self="end" style="padding-bottom:0"
        >
          <ResHL :class="isc+'TXT touchy'">
            <slot>
            </slot>
          </ResHL>
        </v-col>
      </v-row>
    </v-container>
    <div>
      <v-container style="max-width: 1185px;margin-top:20px;">
        <v-row justify="center">
          <v-col cols="12" md="10">

              <v-row justify="center">
                <v-col cols="3"align-self="center" class="align-center">
                  <!--<img
                    src="/img/DSM_IntoxicatingSpaces_pfeil_links_2x.png"
                    class="galleryArrow"
                    @click="index>0?index--:index=imgsLang.length-1"
                    />-->
                    <div
                      :class="arrowClass + ' left'"
                      @click="index>0?index--:index=imgsLang.length-1"
                    ></div>
                </v-col>
                <v-col cols="6" class="justify-center">
                  <img
                    style="max-width:100%;display:block;margin:0 auto;"
                    :src="imgsLang[index].src"
                    @click="visible=true"
                    />
                </v-col>
                <v-col cols="3" class="align-center"  align-self="center">
                  <div
                    :class="arrowClass + ' right'"
                    @click="index === (imgs.length-1) ? index=0 : index++"
                  ></div>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="10" md="6" class="justify-center sub">
                  <p><b>{{imgs[index].inv}}</b></p>
                  <p>{{imgs[index][lang]}}</p>
                  <p>{{imgs[index]['time'+lang]}}</p>
                  <!--<li class="nav-dots">
                    <label v-for="(img, i) in imgs" :key="img.inv" @click="index=i" :class="(i===index) ? 'nav-dot active' : 'nav-dot' "></label>
                  </li>-->
                  <NavDots
                    :items="imgs"
                    :click="function(i){index=i}"
                    :index="index"
                  />
                </v-col>
              </v-row>

              <!-- all props & events -->
              <vue-easy-lightbox
                escDisabled
                moveDisabled
                :visible="visible"
                :imgs="imgsLang"
                :index="index"
                @hide="visible = false"
              >
              <template v-slot:toolbar="{ toolbarMethods }">
                <button @click="toolbarMethods.zoomIn">zoom in</button>
                <button @click="toolbarMethods.zoomOut">zoom out</button>
              </template>
            </vue-easy-lightbox>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<style scoped>
  .sub p{
      margin-bottom:5px;
  }
</style>
<style>
  .vel-img-title{
    white-space: pre-line !important;
    display: none;
  }
  .galleryArrow {
    border: solid #F7D05A;
    border-width: 0 8px 8px 0;
    display: inline-block;
    padding: 50px;
    cursor: pointer;
  }
  .galleryArrow:hover {
    border: solid black;
    border-width: 0 8px 8px 0;
  }
  .galleryArrowSM {
    border: solid #F7D05A;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 20px;
    cursor: pointer;
  }
  .galleryArrowSM:hover {
    border: solid black;
    border-width: 0 3px 3px 0;
  }
  .align-center{
    text-align: center;
    display: flex;
    position: relative;
    align-items: center;
    justify-content:center;
  }
  .left{
    transform: rotate(135deg) skew(-15deg, -15deg);
  }
  .right{
    transform: rotate(-45deg) skew(-15deg, -15deg);
  }
</style>
<script>
import VueEasyLightbox from 'vue-easy-lightbox'
import ResHL from '../components/ResHL' // responsive Headline
import NavDots from '../components/NavDots'

export default {
  components: {
    VueEasyLightbox,
    ResHL,
    NavDots
  },
  name: 'Gallery',
  props: [
    'imgs',
    'lang',
    'isc'
  ],
  data () {
    return {
      visible: false,
      index: 0 // default: 0
    }
  },
  computed: {
    arrowClass () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'galleryArrowSM'
        default: return 'galleryArrow'
      }
    },
    imgsLang () {
      const lang = this.lang
      return this.imgs.map(function (x) {
        return {
          title: x[lang] + '\n' + x['time' + lang],
          src: x.src
        }
      })
    }
  }
}
</script>
